<template>
  <OrModalV3
    :is-open="isOpen"
    size="s"
    data-test="create-queue-form"
    @close="$emit('close')"
  >
    <template #header>
      {{ $t('createQueue.title') }}
    </template>
    <queues-form
      ref="queuesForm"
      error-reference="createQueue"
      :queue="newQueue"
      :is-create="true"
      @add="handleSubmit"
    />
    <template #footer>
      <div class="flex items-center justify-end gap-[16px]">
        <OrButtonV3
          variant="outlined"
          data-test="cancel-queue-creation-button"
          @click="$emit('close')"
        >
          {{ $t('common.cancel') }}
        </OrButtonV3>
        <OrButtonV3
          :loading="isSubmitting"
          data-test="create-queue-button"
          @click="triggerSubmit"
        >
          {{ $t('common.create') }}
        </OrButtonV3>
      </div>
    </template>
  </OrModalV3>
</template>
<script lang="ts">
import { OrButtonV3, OrModalV3 } from '@onereach/ui-components';
import useVuelidate from '@vuelidate/core';
import { defineComponent, ref } from 'vue';
import { CreateQueue, Queue } from '../../types';
import QueuesForm from './QueuesForm.vue';

export default defineComponent({
  name: 'QueuesAddModal',
  components: {
    OrButtonV3,
    QueuesForm,
    OrModalV3,
  },
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    isSubmitting: {
      type: Boolean,
      required: true,
    },
  },
  emits: ['add', 'open', 'close'],
  setup() {
    const queuesForm = ref<InstanceType<typeof QueuesForm>>();

    const v$ = useVuelidate({ $scope: 'QueuesForm' });

    return {
      queuesForm,
      v$,
    };
  },
  data() {
    return {
      newQueue: {
        name: '',
        mrt: '4d',
        redrivePolicy: false,
        mrc: 5,
      } as Queue,
    };
  },
  methods: {
    async triggerSubmit(): Promise<void> {
      this.v$.$touch();
      if (await this.v$.$validate()) {
        this.queuesForm?.add();
      }
    },
    async handleSubmit(queueData: CreateQueue): Promise<void> {
      this.$emit('add', queueData);
    },
  },
});
</script>
